import Dialog, {
  DialogHeader,
  DialogHeading,
} from '@raydiant/raydial/components/Dialog';
import Modal from '@raydiant/raydial/components/Modal';
import Button from '@raydiant/raydial/components/Button';
import Text from '@raydiant/raydial/components/Text';
import { useToastState } from '@raydiant/raydial/components/Toast';
import useDeletePlaylist from '../../../../../hooks/useDeletePlaylist';

interface DeletePlaylistDialogProps {
  isOpen: boolean;
  playlistId?: string;
  playlistName?: string;
  onClose: () => void;
  onSubmit: () => void;
}

const DeletePlaylistDialog = ({
  isOpen,
  playlistId,
  playlistName,
  onClose,
  onSubmit,
}: DeletePlaylistDialogProps) => {
  const toast = useToastState();
  const deletePlaylist = useDeletePlaylist();

  const body = playlistName
    ? `Are you sure you want to delete the "${playlistName}" playlist? This content may be published on devices, and this cannot be undone.`
    : 'Are you sure you want to delete this playlist? This content may be published on devices, and this cannot be undone.';

  const handleDelete = async () => {
    if (!playlistId) return;
    try {
      await deletePlaylist.mutateAsync({ playlistId });
      toast.add({
        title: 'Playlist Deleted',
        description: 'Playlist was deleted successfully',
      });
      onSubmit();
    } catch {
      toast.add({
        title: 'Playlist could not be deleted',
        description: 'Please try again',
        variant: 'caution',
      });
    }
  };

  return (
    <Modal isOpen={isOpen}>
      <Dialog showCloseButton onClose={onClose}>
        <DialogHeader>
          <DialogHeading>
            <span className="text-black">Confirm delete playlist</span>
          </DialogHeading>
        </DialogHeader>

        <div className="px-4 py-6">
          <Text className="text-black" variant="body">
            {body}
          </Text>
        </div>

        <div className="flex flex-col-reverse justify-between pt-2 pb-4 gap-3 px-0 md:gap-6 md:flex-row md:px-4">
          <Button
            onPress={onClose}
            variant="secondary"
            size="large"
            className="grow"
            isDisabled={deletePlaylist.isLoading}
          >
            Cancel
          </Button>
          <Button
            onPress={handleDelete}
            variant="caution"
            size="large"
            className="grow"
            isDisabled={deletePlaylist.isLoading}
            loading={deletePlaylist.isLoading}
          >
            Confirm
          </Button>
        </div>
      </Dialog>
    </Modal>
  );
};

export default DeletePlaylistDialog;
